import Message from '../../src/legacy/Message.tsx';
export default Message;
